import { createContext } from 'react';
import { IModalContextState } from '@components/Modal/context/types';

export const ModalContext = createContext<IModalContextState | undefined>(undefined);
